import { PropTypes } from "base/react-libs";
import classNames from "classnames";
import moment from "moment";
import Icon from "components/elements/icon";
import CommentText from "apps/interactions/components/lazy-comment-text";
import InteractionUtils from "apps/interactions/interaction-utils";

const PinnedComment = ({ comment }) => {

  const isEmptyComment = c => {
    if(!c.text || !c.text.trim()) return "is-empty";
  };

  const formattedDate = () => (
    moment(date_occurred || created_at).format("MMM Do, YYYY")
  );

  const {date_occurred, created_at, author, user_mention, contact_mention } = comment;

  return(
    <div className="pinned-comment">
      <div className="pinned-comment--image">
        <div className="pinned-comment--icon">
          <Icon icon="pin-icon" />
        </div>
      </div>
      <div className="pinned-comment--content">
        <div>
          <div className={classNames("pinned-comment--body", "is-gt-comment", isEmptyComment(comment))}>
            <div className="clearfix">
              <span className="pinned-comment--details">
                Added on {formattedDate()} by {author.name}
              </span>
            </div>
            <div className="pinned-comment--text fs-exclude-data">
              <CommentText 
                text={InteractionUtils.renderText(comment, false, null)}
                mentions={[...user_mention, ...contact_mention]}
              />                           
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

PinnedComment.propTypes = {
  comment: PropTypes.object,
};

export default PinnedComment;